<template>
  <div>
    <button @click="goBack" class="button button-back"><span>Back</span></button>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  mounted () {
  },
  methods: {
    goBack () {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/')
    }
  }
}
</script>
<style scoped lang="scss">
@import "../scss/variables.scss";
.button-back {
  position: absolute;
  top: -60px;
  left: 20px;

  width: auto;
  min-height: auto;
  padding: 6px 10px;
}
</style>
